export const contentData = [
    {
        id:1,
        title: 'Content Management System',
        message: "Content management system includes all the necessary software and methods for producing, editing, curating, and publishing content while maximizing your revenue.",
        image: require('../images/content-manage.svg').default,
        image_name: 'content-manage'
    },
    {
        id:2,
        title: 'Build A Content Marketing Stack',
        message: "Technology is used by marketers to simplify their tasks and gauge their levels of success. A marketing tech stack is a collection of tools used by marketers to carry out various aspects of marketing campaigns.",
        image: require('../images/market-stack.svg').default,
        image_name: 'market-stack'
    },
    {
        id:3,
        title: 'Develop An Evergreen Content Calendar',
        message: "Evergreen content is created with the goal of staying relevant and driving traffic for several months or even several years at a time. ",
        image: require('../images/evergreen-content.svg').default,
        image_name: 'evergreen-content'
    },
    {
        id:4,
        title: 'Conduct Competitive Analysis',
        message: "Critical analysis and competitor research are essential, especially for startups. Understanding and evaluating your competitors' content strategies is done through competitive content analysis. ",
        image: require('../images/competitive-analysis.svg').default,
        image_name: 'competitive-analysis'
    }
];

export const keyData = [
    {
        id:1,
        title: 'Content Strategy',
        message: "Helps you to develop a tailored content strategy to attract and engage with your target audience."
    },
    {
        id:2,
        title: 'Content Creation',
        message: "Creating high-quality, relevant, and engaging content in various formats such as blog posts, articles, infographics, videos, and more."
    },
    {
        id:3,
        title: 'Content Distribution',
        message: "Assists in promoting and distributing content through various channels to maximize its reach and impact."
    }
];